/* eslint-disable react/no-array-index-key */
import { Skeleton } from '@mantine/core';
import React from 'react';
import styles from '../../pages/DetailPages/CommonDetailsComponent/TradersDetails.module.css';

export default function WalletTabLoading({ pageName }) {
  return (
    <section>
      {Array(20)
        .fill()
        .map((item, index) => (
          <div
            key={index}
            className={`${styles.rowContainer} ${styles.shortRow} `}
          >
            <div
              className={`grid items-center transition-transform px-4 p-2 ${pageName === 'Trader' ? styles.traderWalletRowGrid : styles.WalletRowGrid}`}
            >
              <div className="flex items-start gap-3 justify-start">
                <Skeleton circle height={38} width={36} />
                <Skeleton height={15} width={55} mt={10} />

              </div>
              <div className="w-full">
                <Skeleton height={15} width={55} />
              </div>
              <div className="flex flex-cols gap-0 w-full">
                <Skeleton height={15} width={75} />
              </div>
              <div className="flex flex-cols gap-0">
                <div className="gap-1 flex-rows">
                  <Skeleton height={15} width={65} />
                </div>
              </div>
              <div>
                <Skeleton height={15} width={90} />
              </div>
              <div>
                <Skeleton height={15} width={75} />
              </div>
              <div>
                <Skeleton height={15} width={55} />
              </div>
              <div>
                <Skeleton height={15} width={65} />
              </div>
              {pageName === 'CompanyData'
                && (
                  <div>
                    <Skeleton height={15} width={55} />
                  </div>
                )}
            </div>
          </div>
        ))}
    </section>
  );
}
